import { component } from 'picoapp';
import Modal from 'utils/modal';

export default component((node) => {
  const modalElement = node.querySelector('[data-modal]');
  const modal = Modal(modalElement, node);

  document.addEventListener('klaviyo:modal', () => {
    modal.open();
  });

  let watch = true;

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      const parentNode = mutation.target.closest('div.klaviyo-form');

      if (parentNode && parentNode.childNodes.length === 0) {
        modal.close();
        watch = false;
      }
    });
  });

  observer.observe(modalElement, {
    childList: true,
    subtree: true,
  });

  if (!watch) {
    observer.disconnect();
  }
});
